import type { Device } from '@/api/types';

/**
 * Uma "Tag" é outro device do Traccar vinculado ao rastreador principal. O
 * vínculo é guardado em `attributes.linkedTagId` do device principal.
 */
export function getLinkedTagId(device: Device): number | undefined {
  const v = device.attributes?.linkedTagId;
  if (typeof v === 'number' && Number.isFinite(v)) return v;
  if (typeof v === 'string') {
    const n = Number(v);
    return Number.isFinite(n) ? n : undefined;
  }
  return undefined;
}

/**
 * Ids de todos os devices que são Tag (alvo de algum `linkedTagId`). Uma Tag
 * NÃO deve ser listada junto com as máquinas nem entrar em relatórios; ela só
 * aparece via a máquina à qual está vinculada (localização).
 */
export function collectTagIds(devices: Iterable<Device>): Set<number> {
  const ids = new Set<number>();
  for (const d of devices) {
    const linked = getLinkedTagId(d);
    if (linked != null) ids.add(linked);
  }
  return ids;
}
